export default [
  {
    name: 'limit_overview',
    path: '/limit_overview',
    component: () =>
      import(/* webpackChunkName: "limit_overview" */ './LimitOverview.vue')
  },
  {
    name: 'transaction_limit_manage',
    path: '/transaction_limit_manage',
    component: () =>
      import(
        /* webpackChunkName: "transaction_limit_manage" */ './TransactionLimitRule.vue'
      )
  },
  {
    name: 'transaction_limit_warning',
    path: '/transaction_limit_warning',
    component: () =>
      import(
        /* webpackChunkName: "transaction_limit_warning" */ './TransactionLimitWarning.vue'
      )
  },
  {
    name: 'accumulation_query',
    path: '/accumulation_query',
    component: () =>
      import(
        /* webpackChunkName: "accumulation_query" */ './AccumulationQuery.vue'
      )
  },
  {
    name: 'channel_limit',
    path: '/channel_limit',
    component: () =>
      import(/* webpackChunkName: "channel_limit" */ './ChannelLimits.vue')
  }
]
